import type { ConfiguredMiddleware } from 'wretch'
import wretch from 'wretch'
import AbortAddon from 'wretch/addons/abort'
import FormDataAddon from 'wretch/addons/formData'
import FormUrlAddon from 'wretch/addons/formUrl'
import QueryStringAddon from 'wretch/addons/queryString'

export const createClient = (
  baseUrl: string,
  middlewares: ConfiguredMiddleware[] = [],
) =>
  wretch(baseUrl)
    .addon(AbortAddon())
    .addon(QueryStringAddon)
    .addon(FormUrlAddon)
    .addon(FormDataAddon)
    .middlewares(middlewares)

export type Client = ReturnType<typeof createClient>
